import { connect } from 'react-redux';
import ChangePassword from 'components/user/ChangePassword';
import { changePassword } from 'data/app/App.actions';

const mapStateToProps = (state, ownProps) => {
  return {
    error: state.app.authenticationError,
    loading: state.app.loading,
    user: state.app.user,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onChangePassword: (oldPassword, newPassword) =>
      dispatch(changePassword(oldPassword, newPassword)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ChangePassword);
